import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';

/****** Other Modules ******/
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


/****** Interceptors ******/
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './services/interceptors/header.interceptor';

/****** Services ******/
import { LocalStorageService } from './services/local-storage.service';
import { HttpClienteService } from './services/http-cliente.service';
import { AppErrorHandler } from '@core/services/app-error-handler.service';
import { NotificationService } from './services/notification/notification.service';
import { UploadReportsService } from './services/upload-report/upload-report.service';
import { AuthService } from './services/auth/auth.service';
import { ProductsService } from './services/products/products.service';

/****** Guards ******/
import { MainGuard } from './guards/main.guard.service';
import { LoginGuard } from './guards/login.guard.service';
import { RoleGuard } from './guards/role.guard.service';
import { BannersHomeService } from './services/banners-home/banners-home.service';

const SERVICES = [
  LocalStorageService,
  HttpClienteService,
  NotificationService,
  UploadReportsService,
  AuthService,
  ProductsService,
  BannersHomeService
];

const MODULES = [
  CommonModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule
]
const GUARDS = [
  LoginGuard,
  MainGuard,
  RoleGuard
]
const INTERCEPTORS = [
  { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true }
];

@NgModule({
  // declarations: [...COMPONENTS],
  imports: [
    ...MODULES
  ],
  providers: [
    ...SERVICES,
    ...INTERCEPTORS,
    ...GUARDS,
    { provide: ErrorHandler, useClass: AppErrorHandler },
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
